import AWS, {DynamoDB} from 'aws-sdk';

import React        from 'react';
import {withRouter} from 'react-router-dom';

import LeadForm from './LeadForm';

class ContactPage extends React.Component {

    submit = values => {

        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: "us-east-2:def6498a-0b1c-4cde-979f-1bc66de1535d",
            RoleArn: "arn:aws:iam::206787347332:role/Cognito_DynamoPoolUnauth"
        });
        AWS.config.region = "us-east-2";

        // AWS.config.endpoint = "https://dynamodb.us-east-2.amazonaws.com";

        // DEBUG CODE
        // AWS.config.credentials.get( err => {
        //     if(err) {
        //         console.log("ERROR ON credentials.get");
        //         console.log(err);
        //     } else {
        //         console.log("no err");
        //         console.log(AWS.config.credentials)
        //     }
        // } );

        const docClient = new DynamoDB.DocumentClient();
        values.createDate = new Date().toISOString().slice(0, 19).replace(/-/g, '');
        const params = {
            TableName: "UserXUsers",
            Item: values
        };

        const cb = (err, data) => {
            if (err) {
                alert("Sorry: your message didn't go through. Please come again another time.");
                this.props.history.push( '/' );
            } else {
                alert("Success: Your interest is appreciated!");
                this.props.history.push( '/' );
            }
        };

        docClient.put( params, cb.bind(this) );

    };

    render() {
        return(
            <div className='form-wrap'>
                <LeadForm onSubmit={this.submit} />
            </div>
        );
    }

}

ContactPage = withRouter( ContactPage );

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/leadForm/index.js